

<div class="about-page" [attr.data-theme]="theme">

  <!-- Header -->
  <header class="about-header">
    <a class="about-logo" href="/">
      <span class="logo-pxl">pxl</span><span class="logo-vd">vd</span>
    </a>
    <nav class="about-nav">
      <a href="/" class="about-nav-link">← Back to Studio</a>
      <a href="/home/privacy-policy" class="about-nav-link" rel="noopener">Privacy Policy</a>
      <div class="theme-pill">
        <button [class.active]="theme === 'pxlvd'" (click)="setTheme('pxlvd')">pxlvd</button>
        <button [class.active]="theme === 'dark'"  (click)="setTheme('dark')">Dark</button>
        <button [class.active]="theme === 'light'" (click)="setTheme('light')">Light</button>
      </div>
    </nav>
  </header>

  <!-- Tabs -->
  <div class="about-tabs">
    <button class="about-tab" [class.active]="view === 'home'"           (click)="navigate('home')">Home</button>
    <button class="about-tab" [class.active]="view === 'pricing'"        (click)="navigate('pricing')">Pricing</button>
    <button class="about-tab" [class.active]="view === 'privacy-policy'" (click)="navigate('privacy-policy')">Privacy Policy</button>
    <button class="about-tab" [class.active]="view === 'terms'"          (click)="navigate('terms')">Terms of Service</button>
  </div>

  <!-- ── Home ── -->
  <div class="about-content" *ngIf="view === 'home'">
    <div class="about-hero">
      <h1>What is pxlvd?</h1>
      <div class="about-logo-hero">
        <span class="logo-pxl">pxl</span><span class="logo-vd">vd</span><span class="logo-dot">.com</span>
      </div>
      <p class="about-tagline">Pixel video studio</p>
      <p class="about-hero-description">
        pxlvd is a browser-based pixel art and animation app for creating frame-by-frame artwork, collaborating live with teammates, and exporting finished work to GIF, WebM, MP4, PNG, and spritesheets.
      </p>
    </div>

    <div class="about-body">
      <section class="about-section">
        <h2>Who is it for?</h2>
        <p>Indie game developers who need pixel art assets. Content creators making pixel art videos for TikTok and Reels. Pixel art enthusiasts who want a powerful editor without the friction of desktop software.</p>
      </section>

      <section class="about-section">
        <h2>Pricing</h2>
        <p>One-time purchase - no subscriptions, ever. All features included, all future updates free. <a href="/home/pricing" style="color:inherit;text-decoration:underline">See pricing →</a></p>
      </section>

      <section class="about-section">
        <h2>Made in Perth, Western Australia</h2>
        <p>Built with love from Perth, Western Australia 🇦🇺</p>
      </section>

      <section class="about-section">
        <h2>Contact</h2>
        <p>Questions or support? Reach us at <a href="mailto:manoj@pxlvd.com">manoj@pxlvd.com</a></p>
      </section>

      <div class="about-links">
        <a class="about-link-btn" href="/home/privacy-policy/">Privacy Policy</a>
        <span class="about-link-sep">·</span>
        <a class="about-link-btn" href="/home/terms/">Terms of Service</a>
        <span class="about-link-sep">·</span>
        <a class="about-link-btn" href="/docs" target="_blank" rel="noopener">Documentation</a>
      </div>
    </div>
  </div>

  <!-- ── Privacy Policy ── -->
  <div class="about-content" *ngIf="view === 'privacy-policy'">
    <div class="legal-header">
      <h1>Privacy Policy</h1>
      <p class="legal-date">Last updated: March 2026</p>
    </div>
    <div class="legal-body">
      <section class="legal-section">
        <h2>1. Who we are</h2>
        <p>pxlvd ("we", "us", "our") is a pixel art and animation studio available at <a href="https://pxlvd.com">pxlvd.com</a>, operated by Team pxlvd based in Perth, Western Australia. You can contact us at <a href="mailto:manoj@pxlvd.com">manoj@pxlvd.com</a>.</p>
      </section>
      <section class="legal-section">
        <h2>2. Information we collect</h2>
        <p>We collect only the minimum information required to operate the service:</p>
        <ul>
          <li><strong>Account information:</strong> Your email address and name when you register via email or Google sign-in.</li>
          <li><strong>Payment status:</strong> Whether your account has a valid purchase. We do not store card details - payment is handled entirely by our payment provider.</li>
          <li><strong>Analytics:</strong> Anonymous page view data collected via Cloudflare Web Analytics. This data contains no personal identifiers and uses no cookies.</li>
          <li><strong>Error data:</strong> Anonymous error reports collected via Sentry to help us identify and fix bugs. These reports do not contain your artwork or personal data.</li>
        </ul>
      </section>
      <section class="legal-section">
        <h2>3. What we do not collect</h2>
        <ul>
          <li><strong>Your artwork:</strong> All pixel art and projects you create are stored locally in your browser (IndexedDB). We do not upload, store, or access your canvas data on our servers.</li>
          <li><strong>Collaboration canvas data:</strong> When you use a real-time collaboration session, your canvas data is synced peer-to-peer directly between collaborators via WebRTC. Our signaling server only brokers the connection - it never sees, stores, or processes your canvas content.</li>
        </ul>
      </section>
      <section class="legal-section">
        <h2>4. How we use your information</h2>
        <ul>
          <li>To create and manage your account.</li>
          <li>To verify your purchase and grant access to the app.</li>
          <li>To send transactional emails such as purchase confirmation and password reset.</li>
          <li>To identify and fix errors in the application.</li>
          <li>We do not sell your data to any third party.</li>
          <li>We do not use your data for advertising or profiling.</li>
        </ul>
      </section>
      <section class="legal-section">
        <h2>5. Third-party services</h2>
        <ul>
          <li><strong>Supabase</strong> - authentication and user account management. <a href="https://supabase.com/privacy" target="_blank" rel="noopener">Privacy Policy</a></li>
          <li><strong>Cloudflare</strong> - hosting, CDN, and anonymous analytics. <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener">Privacy Policy</a></li>
          <li><strong>Sentry</strong> - anonymous error monitoring. <a href="https://sentry.io/privacy/" target="_blank" rel="noopener">Privacy Policy</a></li>
          <li><strong>Google OAuth</strong> - optional sign-in with Google. <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Privacy Policy</a></li>
        </ul>
      </section>
      <section class="legal-section">
        <h2>6. Cookies</h2>
        <p>pxlvd uses only essential session cookies required for authentication. We do not use tracking cookies, advertising cookies, or third-party cookies for analytics. Cloudflare Web Analytics is cookieless.</p>
      </section>
      <section class="legal-section">
        <h2>7. Data retention</h2>
        <p>We retain your account data for as long as your account remains active. You may request deletion of your account and all associated personal data at any time by emailing <a href="mailto:manoj@pxlvd.com">manoj@pxlvd.com</a>. We will process deletion requests within 30 days.</p>
      </section>
      <section class="legal-section">
        <h2>8. Your rights under GDPR</h2>
        <p>If you are located in the European Union or European Economic Area, you have the following rights under the General Data Protection Regulation (GDPR):</p>
        <ul>
          <li><strong>Right of access:</strong> You may request a copy of the personal data we hold about you.</li>
          <li><strong>Right to rectification:</strong> You may request correction of inaccurate personal data.</li>
          <li><strong>Right to erasure:</strong> You may request deletion of your personal data ("right to be forgotten").</li>
          <li><strong>Right to restriction:</strong> You may request that we limit how we process your data.</li>
          <li><strong>Right to data portability:</strong> You may request your data in a machine-readable format.</li>
          <li><strong>Right to object:</strong> You may object to our processing of your personal data.</li>
          <li><strong>Lawful basis for processing:</strong> We process your data on the basis of contract performance (providing the service you purchased) and legitimate interests (security and error monitoring).</li>
        </ul>
        <p>To exercise any of these rights, contact us at <a href="mailto:manoj@pxlvd.com">manoj@pxlvd.com</a>. If you believe we have not adequately addressed your concern, you have the right to lodge a complaint with your local data protection authority.</p>
      </section>
      <section class="legal-section">
        <h2>9. Australian Privacy Act</h2>
        <p>We handle personal information in accordance with the Australian Privacy Act 1988 and the Australian Privacy Principles (APPs). You have the right to access and correct personal information we hold about you. Contact us at <a href="mailto:manoj@pxlvd.com">manoj@pxlvd.com</a> to exercise these rights.</p>
      </section>
      <section class="legal-section">
        <h2>10. Children's privacy</h2>
        <p>pxlvd is intended for users aged 13 and over. We do not knowingly collect personal information from children under 13. If we become aware that a user under 13 has provided personal data, we will delete that information promptly. If you believe a child under 13 has registered, please contact us at <a href="mailto:manoj@pxlvd.com">manoj@pxlvd.com</a>.</p>
      </section>
      <section class="legal-section">
        <h2>11. Changes to this policy</h2>
        <p>We may update this Privacy Policy from time to time. We will notify registered users of material changes via email at least 14 days before they take effect. Continued use of pxlvd after changes take effect constitutes acceptance of the updated policy.</p>
      </section>
    </div>
  </div>

  <!-- ── Terms of Service ── -->
  <div class="about-content" *ngIf="view === 'terms'">
    <div class="legal-header">
      <h1>Terms of Service</h1>
      <p class="legal-date">Last updated: March 2026</p>
    </div>
    <div class="legal-body">
      <section class="legal-section">
        <h2>1. Acceptance</h2>
        <p>By accessing or using pxlvd at <a href="https://pxlvd.com">pxlvd.com</a> you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree, do not use the service.</p>
      </section>
      <section class="legal-section">
        <h2>2. The service</h2>
        <p>pxlvd is a web-based pixel art and animation studio operated by <strong>pxlvd</strong> (legal name: pxlvd), based in Perth, Western Australia. We provide the software on an as-is basis and reserve the right to modify, update, or discontinue any part of the service at any time with reasonable notice.</p>
      </section>
      <section class="legal-section">
        <h2>3. Eligibility</h2>
        <p>You must be at least 13 years of age to use pxlvd. By using pxlvd you represent that you meet this requirement. If you are between 13 and 18, you represent that you have your parent or guardian's permission to use the service.</p>
      </section>
      <section class="legal-section">
        <h2>4. Accounts</h2>
        <ul>
          <li>You must provide accurate and current information when creating an account.</li>
          <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
          <li>You may not share your account with others or create accounts on behalf of others.</li>
          <li>You must notify us immediately at <a href="mailto:manoj@pxlvd.com">manoj@pxlvd.com</a> if you suspect unauthorised access to your account.</li>
        </ul>
      </section>
      <section class="legal-section">
        <h2>5. Purchase and licence</h2>
        <ul>
          <li>pxlvd is sold as a one-time purchase. Payment grants you a personal, non-exclusive, non-transferable licence to use the software.</li>
          <li>You may not resell, sublicence, share, or otherwise transfer your access to pxlvd to any third party.</li>
          <li>All future updates to pxlvd are included in your one-time purchase at no additional cost.</li>
        </ul>
      </section>
      <section class="legal-section">
        <h2>6. Refund policy</h2>
        <p>We offer a full refund within <strong>14 days</strong> of purchase, no questions asked. To request a refund, contact us at <a href="mailto:manoj@pxlvd.com">manoj@pxlvd.com</a> within 14 days of your purchase date and we will process your refund promptly. After 14 days, all purchases are final.</p>
      </section>
      <section class="legal-section">
        <h2>7. Your content</h2>
        <ul>
          <li>You retain full ownership of all pixel art and creative work you produce using pxlvd.</li>
          <li>We claim no rights over your artwork.</li>
          <li>Your canvas data is stored locally in your browser and is never uploaded to our servers. See our Privacy Policy for details on how collaboration data is handled.</li>
          <li>You are solely responsible for ensuring your content does not infringe the intellectual property rights of others.</li>
        </ul>
      </section>
      <section class="legal-section">
        <h2>8. Prohibited use</h2>
        <p>You may not use pxlvd to:</p>
        <ul>
          <li>Violate any applicable law or regulation.</li>
          <li>Create or distribute content that is illegal, harmful, defamatory, or infringes third-party rights.</li>
          <li>Attempt to reverse engineer, decompile, or extract the source code of pxlvd.</li>
          <li>Interfere with or disrupt the service, servers, or networks connected to the service.</li>
          <li>Use automated tools to access or scrape the service.</li>
        </ul>
      </section>
      <section class="legal-section">
        <h2>9. Disclaimer of warranties</h2>
        <p>pxlvd is provided "as is" and "as available" without warranties of any kind, express or implied. We do not warrant that the service will be uninterrupted, error-free, or meet your specific requirements. To the extent permitted by law, we exclude all implied warranties.</p>
      </section>
      <section class="legal-section">
        <h2>10. Limitation of liability</h2>
        <p>To the maximum extent permitted by applicable law, pxlvd shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of or inability to use the service, including any loss of artwork or data. Nothing in these terms limits liability that cannot be excluded under Australian Consumer Law.</p>
      </section>
      <section class="legal-section">
        <h2>11. Governing law</h2>
        <p>These terms are governed by the laws of Western Australia, Australia. Any disputes arising from these terms or your use of pxlvd shall be subject to the exclusive jurisdiction of the courts of Western Australia.</p>
      </section>
      <section class="legal-section">
        <h2>12. Changes to these terms</h2>
        <p>We may update these Terms of Service from time to time. We will notify registered users of material changes via email at least 14 days before they take effect. Continued use of pxlvd after changes take effect constitutes acceptance of the updated terms.</p>
      </section>
      <section class="legal-section">
        <h2>13. Contact</h2>
        <p>For any questions about these terms, contact us at <a href="mailto:manoj@pxlvd.com">manoj@pxlvd.com</a>.</p>
      </section>
    </div>
  </div>

  <!-- ── Pricing ── -->
  <div class="about-content pricing-view" *ngIf="view === 'pricing'">

    <div class="pricing-card">

      <div class="pricing-sandbox-badge" *ngIf="isSandbox$ | async">Sandbox / Test mode</div>
      <div class="pricing-badge">One-time purchase</div>

      <!-- Logged-in pill -->
      <div class="pricing-user-pill" *ngIf="auth.user">
        Purchasing as <span>{{ auth.user.email }}</span>
      </div>

      <!-- Price -->
      <div class="pricing-price-row">
        <span class="pxl-spinner pricing-spinner" *ngIf="(configStatus$ | async) === 'loading'"></span>
        <span class="pricing-amount" *ngIf="(configStatus$ | async) !== 'loading'">{{ priceDisplay }}</span>
      </div>
      <p class="pricing-currency" *ngIf="(configStatus$ | async) !== 'loading' && !(configError$ | async)">{{ priceNote }}</p>
      <p class="pricing-currency error-text" *ngIf="configError$ | async as err">{{ err }}</p>

      <!-- Features -->
      <ul class="pricing-features">
        <li>Full pixel art &amp; animation editor</li>
        <li>Real-time multiplayer collaboration</li>
        <li>Layer support with blend modes</li>
        <li>Export to GIF, WebM, PNG spritesheet</li>
        <li>Symmetry painting (radial, star, quad)</li>
        <li>Onion skinning &amp; keyframe tweens</li>
        <li>All future updates included</li>
      </ul>

      <!-- Not logged in -->
      <ng-container *ngIf="!auth.user">
        <p class="pricing-login-note"><strong>Sign in to purchase.</strong> Your purchase will be linked to your account so you can access it from any device.</p>
        <button class="pricing-btn-primary" (click)="requestLogin()">Sign in to pxlvd →</button>
      </ng-container>

      <!-- Logged in - already paid -->
      <div class="pricing-already-paid" *ngIf="auth.user && (hasPaid$ | async)">
        <div class="pricing-paid-icon">✓</div>
        <p class="pricing-paid-title">You already have access</p>
        <p class="pricing-paid-sub">Your purchase is active. <a href="/">Open Studio →</a></p>
      </div>

      <!-- Logged in - not yet paid -->
      <button class="pricing-btn-primary"
              *ngIf="auth.user && !(hasPaid$ | async)"
              [disabled]="(configStatus$ | async) === 'loading' || !!(configError$ | async) || checkoutLoading"
              (click)="openCheckout()">
        {{ checkoutLoading ? 'Opening…' : (configStatus$ | async) === 'loading' ? 'Loading…' : 'Buy now' }}
      </button>

      <hr class="pricing-divider">
      <p class="pricing-guarantee">
        <strong>14-day money-back guarantee.</strong><br>
        Not happy? Email <a href="mailto:manoj@pxlvd.com">manoj&#64;pxlvd.com</a> within 14 days for a full refund, no questions asked.<br><br>
        By purchasing you agree to our <button class="pricing-text-link" (click)="navigate('terms')">Terms of Service</button> and <button class="pricing-text-link" (click)="navigate('privacy-policy')">Privacy Policy</button>.
      </p>
    </div>

  </div>

  <!-- Footer -->
  <footer class="about-footer">
    <span>© 2026 pxlvd. Made in Perth, Western Australia.</span>
    <div class="about-footer-links">
      <a class="about-link-btn" href="/home/privacy-policy/">Privacy</a>
      <span>·</span>
      <a class="about-link-btn" href="/home/terms/">Terms</a>
      <span>·</span>
      <a class="about-link-btn" href="mailto:manoj@pxlvd.com">Contact</a>
    </div>
  </footer>

</div>


